import { render, staticRenderFns } from "./EventJoinPublic.vue?vue&type=template&id=ff5c7494"
import script from "./EventJoinPublic.vue?vue&type=script&lang=ts"
export * from "./EventJoinPublic.vue?vue&type=script&lang=ts"
import style0 from "./EventJoinPublic.vue?vue&type=style&index=0&id=ff5c7494&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports